import {storyApi} from '@/contexts/api-context';

export const getCompaniesLatestStories = async (
  companyId: number,
  limit: number,
  initOverrides?: RequestInit,
) => storyApi.getCompanyStoriesLatest({companyId, limit}, initOverrides);
